module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/icon//icon-diamond.png?v=022d8f1f";